var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('dv-decoration-12',{staticStyle:{"width":"70px","height":"70px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }